__webpack_require__.p = "https://www.brightfunds.org/packs/";